import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTeamStore } from '../../lib/store/teamStore';
import Card from '../common/Card';
import Button from '../common/Button';
import Alert from '../common/Alert';

export const TeamList = () => {
  const { teams, isLoading, error, fetchUserTeams } = useTeamStore();
  
  useEffect(() => {
    fetchUserTeams();
  }, [fetchUserTeams]);
  
  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <div className="animate-spin h-8 w-8 border-t-2 border-b-2 border-primary rounded-full"></div>
      </div>
    );
  }
  
  if (error) {
    return (
      <Alert variant="error" className="my-4">
        Failed to load teams: {error}
      </Alert>
    );
  }
  
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-semibold">Your Teams</h2>
        <Link to="/teams/create">
          <Button variant="primary">Create New Team</Button>
        </Link>
      </div>
      
      {teams.length === 0 ? (
        <Card className="p-8 text-center">
          <h3 className="text-xl font-medium mb-2">No Teams Yet</h3>
          <p className="text-gray-600 mb-6">
            Create your first team to get started with ShiftNapse.
          </p>
          <Link to="/teams/create">
            <Button variant="primary">Create a Team</Button>
          </Link>
        </Card>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {teams.map(team => (
            <Link to={`/teams/${team.id}/dashboard`} key={team.id}>
              <Card className="p-6 hover:shadow-md transition-shadow">
                <h3 className="text-xl font-medium mb-2">{team.name}</h3>
                <div className="text-sm text-gray-600 mb-4">
                  Created on {new Date(team.created_at || '').toLocaleDateString()}
                </div>
                <div className="grid grid-cols-2 gap-2 text-sm">
                  <div className="text-gray-500">Day Providers:</div>
                  <div>{team.day_providers_required}</div>
                  <div className="text-gray-500">Night Providers:</div>
                  <div>{team.night_providers_required}</div>
                  <div className="text-gray-500">Scheduling Period:</div>
                  <div>{team.scheduling_period_days} days</div>
                </div>
              </Card>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}; 